import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { partialResetApplication } from "../redux/features/applicationState/applicationStateSlice";

export const usePartialApplicationReset = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const onBeforeUnload = (event) => {
      event.preventDefault();

      dispatch(partialResetApplication());
    };

    window.addEventListener("beforeunload", onBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, [dispatch]);
};
